import Input from "../helper/FieldInput";
import React, { useState } from "react";
import { Controller } from "react-hook-form";
import handleErrorMsg from "../helper/handleErrorMsg";
import useTranslation from "next-translate/useTranslation";
import { FormControl, IconButton, InputAdornment } from "@mui/material";
import { Icon } from "@utils/helper";

export default function PasswordInputController({
  name,
  control,
  rules,
  defaultValue = "",
  ...otherProps
}) {
  const { t } = useTranslation("common-locale");
  const [showPassword, setShowPassword] = useState(false);
  const handleShow = () => setShowPassword((old) => !old);

  return (
    <FormControl fullWidth>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({
          field: { value, ...otherRenderProps },
          fieldState: { error },
        }) => {
          return (
            <div>
              <Input
                error={Boolean(error)}
                value={value ?? ""}
                helperText={handleErrorMsg(error, t)}
                type={showPassword ? "text" : "password"}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={handleShow}
                      >
                        {showPassword ? (
                          <Icon
                            width={18}
                            height={18}
                            className="text-[#8F8F8F]"
                            id="r3-c11"
                          />
                        ) : (
                          <Icon
                            width={18}
                            height={18}
                            className="text-[#8F8F8F]"
                            id="r3-c10"
                          />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                {...otherProps}
                {...otherRenderProps}
                showPassword={showPassword}
              />
            </div>
          );
        }}
        defaultValue={defaultValue}
      />
    </FormControl>
  );
}
